import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, InfoIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

const Hero = () => {
  return (
    <section className="relative bg-[#05111e] bg-[url('/decidedigital-uploads/lex-home-mobile.png')] md:bg-[url('/decidedigital-uploads/lex-home.png')] bg-cover bg-center md:bg-[center_right] bg-no-repeat pt-32 pb-20 md:pt-40 md:pb-28 lg:pt-48 lg:pb-36 overflow-hidden">
      {/* Soft gradient overlay to ensure perfect readability on all viewport sizes */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#05111e]/90 via-[#05111e]/80 to-[#05111e]/90 md:bg-gradient-to-r md:from-[#05111e] md:via-[#05111e]/85 md:to-transparent pointer-events-none z-0" />


      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl">
          {/* Accent Line */}
          <div className="w-14 h-[3px] bg-[#D4AF37] mb-8 rounded-full" />

          {/* Title */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-display text-white mb-4 tracking-tight">
            LexPrompt
          </h1>

          {/* Subtitle */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6 leading-snug">
            IA e produtividade para profissionais do Direito.
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-base sm:text-lg mb-10 max-w-xl leading-relaxed">
            Economize tempo e aumente sua produtividade com prompts específicos para diversas áreas do Direito. Desenvolvido para profissionais jurídicos.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <Button
              asChild
              size="lg"
              className="bg-[#D4AF37] hover:bg-[#BFA02A] text-[#072A45] font-semibold px-7 py-6 text-base rounded-md shadow-lg transition-colors border-0"
            >
              <Link to="/auth/register" className="flex items-center justify-center">
                Começar Agora
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-white/40 text-white hover:bg-white/10 hover:text-white bg-transparent px-7 py-6 text-base rounded-md transition-colors"
            >
              <Link to="/how-to-use" className="flex items-center justify-center">
                <InfoIcon className="mr-2 h-5 w-5 text-gray-300" />
                Como Funciona
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
